import React from 'react';
import { Box, Divider, Skeleton, Stack, Typography } from '@mui/material';
import { Card, Heading, IconButtonGroup, useMediaDevice } from '@travelity/ui';

export interface EventItemProps {}

const EventItemSkeleton: React.FC<EventItemProps> = () => {
    const { isMobile } = useMediaDevice();

    return (
        <Box>
            <Stack
                direction="row"
                justifyContent="space-between"
                sx={{
                    mt: 2,
                    mb: 1,
                    pr: 5,
                    minWidth: 0,
                }}
            >
                <Stack
                    direction="row"
                    gap={1.5}
                    alignItems="center"
                    sx={{
                        minWidth: 0,
                    }}
                >
                    <Heading
                        sx={{
                            fontSize: '14px',
                            fontWeight: '600',
                            pr: 1,
                        }}
                        alpha={0.7}
                        ellipsis
                    >
                        <Skeleton width={150} sx={{ fontSize: '24px' }} />
                    </Heading>
                    <Typography
                        sx={{
                            ml: '-8px',
                            color: '#6B748C',
                            fontSize: '12px',
                            fontWeight: '500',
                            whiteSpace: 'nowrap',
                            pr: 1.5,
                        }}
                    >
                        <Skeleton width={80} sx={{ fontSize: '24px' }} />
                    </Typography>
                </Stack>
                {!isMobile && (
                    <Stack direction="row" gap={1}>
                        <Skeleton width={120} sx={{ fontSize: '24px' }} />
                        <Skeleton width={120} sx={{ fontSize: '24px' }} />
                    </Stack>
                )}
            </Stack>
            <Card
                sx={{
                    height: '128px',
                }}
                justifyContent="space-evenly"
                leftAdornment={
                    isMobile ? undefined : (
                        <Box
                            sx={{
                                width: '88px',
                                height: '88px',
                                p: 1,
                                borderRadius: '12px',
                                bgcolor: '#FFF',
                                boxShadow:
                                    '0px 0px 16px 0px rgba(178, 185, 205, 0.50)',
                            }}
                        >
                            <Skeleton
                                variant="rectangular"
                                width="100%"
                                height="100%"
                            />
                        </Box>
                    )
                }
                buttons={
                    <>
                        <IconButtonGroup
                            flexShrink={0}
                            sx={{ px: 0.75, py: 1 }}
                            gap={1.5}
                        >
                            <Skeleton
                                variant="circular"
                                width={24}
                                height={24}
                            />
                            <Skeleton
                                variant="circular"
                                width={24}
                                height={24}
                            />
                        </IconButtonGroup>
                        <IconButtonGroup
                            flexShrink={0}
                            sx={{ px: 0.75, py: 1 }}
                            gap={1.5}
                        >
                            <Skeleton
                                variant="circular"
                                width={24}
                                height={24}
                            />
                        </IconButtonGroup>
                    </>
                }
            >
                <Stack
                    gap={1}
                    sx={{
                        p: 2,
                    }}
                >
                    <Stack
                        direction="row"
                        gap={2}
                        justifyContent="space-between"
                        sx={{
                            width: 1,
                            px: 2,
                            pt: '10px',
                            pb: '10px',
                        }}
                    >
                        <Skeleton width={90} sx={{ fontSize: '24px' }} />
                        <Skeleton width={30} sx={{ fontSize: '24px' }} />
                    </Stack>
                    <Divider />
                    <Stack
                        direction="row"
                        gap={2}
                        justifyContent="space-between"
                        sx={{
                            width: 1,
                            px: 2,
                            pt: '8px',
                            pb: '12px',
                        }}
                    >
                        {!isMobile && (
                            <Skeleton width={90} sx={{ fontSize: '24px' }} />
                        )}
                        <Stack direction="row" gap={1}>
                            <Skeleton width={100} sx={{ fontSize: '24px' }} />
                            <Skeleton width={100} sx={{ fontSize: '24px' }} />
                            <Skeleton width={40} sx={{ fontSize: '24px' }} />
                        </Stack>
                    </Stack>
                </Stack>
            </Card>
        </Box>
    );
};

export default EventItemSkeleton;
